// extracted by mini-css-extract-plugin
export default {"wrapper":"Ty-z","viewport":"Uy-z","container":"Vy-z","slide":"Wy-z"};